import type React from 'react';

import { tailwindMerge } from '../../../tailwind';
import { CloseOutlinedIcon } from '../../Icons';
import { Header } from '../../theme';
import { useModalContext } from './ModalContext';

export const ModalHeader = ({
  className,
  children,
  ...props
}: {
  className?: string;
  children: React.ReactNode;
} & React.HTMLAttributes<HTMLDivElement>) => {
  const { onClose, dismissible } = useModalContext();
  return (
    <div
      className={tailwindMerge(
        'p-l tablet:rounded-t tablet:bg-background-grey-light tablet:p-m flex items-center justify-between',
        className,
      )}
      {...props}
    >
      <div id="modal-title">
        <Header tag="h1" size="xl">
          {children}
        </Header>
      </div>
      {dismissible && onClose && (
        <button onClick={onClose} className="mr-s" aria-label="close">
          <CloseOutlinedIcon
            data-testid="close-icon"
            size={16}
            className="stroke-grey cursor-pointer"
          />
        </button>
      )}
    </div>
  );
};

ModalHeader.displayName = 'Modal.Header';
